import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/examine/task/main/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/examine/task/main/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/examine/task/main/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/examine/task/main/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/examine/task/main/submit', params,options);

export const getTaskReport = (params, options) =>
  request.get('/api/v4ward/examine/task/getTaskReport', Object.assign({}, options, { params }));

export const generate = (params, options) =>
  request.post('/api/v4ward/examine/report/generate', params,options);

